export function loadMatomo() {
  if (typeof window === 'undefined') return;

  setTimeout(function () {
    // 延迟加载Matomo脚本
    const MATOMO_SCRIPT_SRC =
      process.env.NODE_ENV === 'production'
        ? "https://matomo.crazysales.com.au/js/container_9AlR6d7o.js?v=1.0.0"
        : "https://matomo-uat.crazysales.com.au/js/container_N462kcUb.js?v=1.0.0";

    let script = document.createElement('script')
    script.id = 'matomo'
    script.async = true
    script.innerHTML = `var _mtm = window._mtm = window._mtm || [];
    _mtm.push({'mtm.startTime': (new Date().getTime()), 'event': 'mtm.Start'});
    var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];
    g.async=true; g.src='${MATOMO_SCRIPT_SRC}'; s.parentNode.insertBefore(g,s);`

    document.head.appendChild(script)
  }, 1); // 立即加载
}